import Agreement from './agreement/ContractSideMenuAgreementsList';
import ChannelDistribution from './channelDistribution/ContractSideMenuChannelDistribution';
import ContractTemplate from './contract/ContractSideMenuContractTemplatesList';
import DigitalDistribution from './digitalDistribution/ContractSideMenuDigitalDistributionsList';
import MerchDistribution from './merchDistribution/ContractSideMenuMerchDistribution';
import ParagraphSection from './paragraphSection/ContractSideMenuParagraphSectionsList';
import PhysicalDistribution from './physicalDistribution/ContractSideMenuPhysicalDistributionsList';
import Section from './section/ContractSideMenuSectionsList';

export default {
  Agreement,
  DigitalDistribution,
  Section,
  ParagraphSection,
  ContractTemplate,
  MerchDistribution,
  ChannelDistribution,
  PhysicalDistribution,
};
